<span class="breadcrumb-link" *ngFor="let breadcrumbsItem of breadcrumbsItems | slice:0:breadcrumbsItems.length - 1"
      (click)="gotoBreadcrumbPage(breadcrumbsItem)">
  {{breadcrumbsItem.pageTitle}} {{zeroPad(breadcrumbsItem.pageId, 6)}}<span class="splitter">/</span>
</span>
<span class="breadcrumb-last" *ngIf="breadcrumbsItems[breadcrumbsItems.length-1]">
  {{breadcrumbsItems[breadcrumbsItems.length-1].pageTitle}}
  {{zeroPad(breadcrumbsItems[breadcrumbsItems.length-1].pageId, 6)}}
</span>
